export function getISODate(date) {
  const month =
    date.getMonth() + 1 < 10
      ? `0${date.getMonth() + 1}`
      : `${date.getMonth() + 1}`;
  const day = date.getDate() < 10 ? `0${date.getDate()}` : `${date.getDate()}`;
  return `${date.getFullYear()}-${month}-${day}`;
}

export function getDateFromISO(dateString) {
  return new Date(
    dateString.substring(0, 3),
    parseInt(dateString.substring(5, 6), 10),
    dateString.substring(7, 8)
  );
}

export const getLocalDate = strDate => {
  const date = new Date(strDate);
  date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
  return date.toLocaleDateString("es");
};

export const toDateFromString = d => {
  return new Date(new Date(d).setMinutes(new Date().getTimezoneOffset())); // this receives a date in format '2020-01-01' return a date
};

export const toDateTime = d => {
  var day = new Date(d);
  return new Date(day.getUTCFullYear(), day.getUTCMonth(), day.getUTCDate());
};

export function toFormatDate(date) {
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
}

export function toFormatDateReverse(date) {
  var parts = date.split('/'); 
  var d = new Date(parts[2], parts[1] - 1, parts[0]);
  var month = "" + (d.getMonth() + 1);
  var day = "" + d.getDate();
  var year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
}

export const addMonth = function(date, monthsToAdd) {
  const d = date;
  d.setMonth(d.getMonth() + monthsToAdd);
  return d;
};

export const addDay = function(date, daysToAdd) {
  const d = date;
  d.setDate(d.getDate() + daysToAdd);
  return d;
};

export function parseDate(date) {
  if (!date || date == "" || date == "0000-00-00") {
    return "";
  }
  if (date instanceof Date) {
    return date.toISOString();
  }

  if (date.indexOf("T") > -1) {
    return date;
  }
  try{
  return new Date(`${date}T00:00`).toISOString();
  }catch(e){
    return date;
  }
}

export function adjustUTCtoLocal(dateInput) {
  if (!dateInput) return null;

  if (dateInput instanceof Date) {
    return dateInput; // ya está local, no tocar
  }

  if (typeof dateInput === 'string') {
    // parse manual como local
    const [datePart, timePart] = dateInput.split("T");
    if (!datePart || !timePart) return null;
    const [year, month, day] = datePart.split("-").map(Number);
    const [hour, minute, second] = timePart.split(":").map(Number);
    return new Date(year, month - 1, day, hour, minute, second);
  }

  return null;
}

export const getTodayISO = () => new Date().toISOString().slice(0, 10);

export const isFutureOrToday = (date) => {
  if (!date) return false;
  return date >= getTodayISO();
};